import { render, staticRenderFns } from "./ComplaintForm.vue?vue&type=template&id=73fe39e2&scoped=true"
import script from "./ComplaintForm.vue?vue&type=script&lang=js"
export * from "./ComplaintForm.vue?vue&type=script&lang=js"
import style0 from "./ComplaintForm.vue?vue&type=style&index=0&id=73fe39e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fe39e2",
  null
  
)

export default component.exports